module.exports = __webpack_public_path__ + "static/media/slide-2-mobile.fca2d08f.png";